<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="仓库质检" v-if="findChildren(155)!==-1" name="qualitytest" style="height: 100%;">
				<qualitytest-index />
			</el-tab-pane>
			<el-tab-pane label="质检退换" v-if="findChildren(161)!==-1" name="qualitytestpurchaseback" style="height: 100%;">
				<qualitytestpurchaseback-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import qualitytestIndex from './qualitytest/index.vue'
	import qualitytestpurchasebackIndex from './qualitytestpurchaseback/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				
				activeName: 'qualitytest',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			// if(this.departmentChildren.length!=0){
			// 	this.activeName = this.departmentChildren[0].controller
			// }
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			qualitytestIndex,
			qualitytestpurchasebackIndex

		}
	}
</script>
